import type { TokenResponse } from '@et/shared';
import { useState, type FormEvent } from 'react';
import { api, describeError, session } from '../api/client';
import { useLang, useT } from '../lib/i18n';

export function Login(): JSX.Element {
  const t = useT();
  const { lang, setLang } = useLang();
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  const submit = async (e: FormEvent): Promise<void> => {
    e.preventDefault();
    setBusy(true);
    setError(null);
    try {
      session.set(await api.post<TokenResponse>('/auth/login', { password }));
    } catch (err) {
      setError(describeError(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div style={{ minHeight: '100vh', display: 'grid', placeItems: 'center', padding: 16 }}>
      <form className="card stack" style={{ width: 'min(360px, 100%)' }} onSubmit={(e) => void submit(e)}>
        <h1 style={{ margin: 0 }}>ET-TradeBot</h1>
        <label className="field">
          {t('Password')}
          <input type="password" autoFocus autoComplete="current-password" value={password} onChange={(e) => { setPassword(e.target.value); }} />
        </label>
        {error && <div className="neg">{error}</div>}
        <button className="primary" disabled={busy || password.length === 0}>{busy ? t('Signing in…') : t('Sign in')}</button>
        <div className="row" style={{ justifyContent: 'center' }}>
          <button type="button" className={`small ${lang === 'tr' ? 'primary' : ''}`} onClick={() => { setLang('tr'); }}>Türkçe</button>
          <button type="button" className={`small ${lang === 'en' ? 'primary' : ''}`} onClick={() => { setLang('en'); }}>English</button>
        </div>
      </form>
    </div>
  );
}
